import React from 'react';
import PropTypes from 'prop-types';

import { LRS_ACTIONS } from '@techchange/components';

import { RESOURCE_TYPES } from '../../../../constants';
import RuleEditorForm from '../../RuleEditorForm';


const propTypes = {

	/**
	 * The resource.
	 */
	resource: PropTypes.shape({

		/**
		 * The resource ID.
		 */
		id: PropTypes.string.isRequired,

		/**
		 * The resource type.
		 */
		type: PropTypes.oneOf([RESOURCE_TYPES.EMBED]).isRequired,

		/*
		 * The resource title.
		 */
		title: PropTypes.string.isRequired,

	}).isRequired,

	/**
	 * The rule for the resource.
	 */
	rule: PropTypes.shape({

		/**
		 * The condition for the rule.
		 */
		condition: PropTypes.shape({

			/**
			 * The list of subconditions for the condition.
			 */
			subconditions: PropTypes.arrayOf(PropTypes.shape({

				/**
				 * The subcondition ID.
				 */
				id: PropTypes.string,

			})),

		}),

	}),

	/**
	 * The parent resource.
	 */
	parent: PropTypes.shape({

		/**
		 * The parent resource ID.
		 */
		id: PropTypes.string.isRequired,

	}).isRequired,

	/**
	 * The current user's ID.
	 */
	userId: PropTypes.string.isRequired,

	/**
	 * Callback function to handle saving the completion rule.
	 */
	onSave: PropTypes.func.isRequired,

	/**
	 * Callback function to handle cancelling the editor for the completion rule.
	 */
	onCancel: PropTypes.func.isRequired,

};

const RuleEditor = (props) => {

	const { id, type, title } = props.resource;

	// Defines the list of possible completion requirements,
	// i.e. subconditions, for the completion rule.
	const initialValues = [{
		active: false,
		action: LRS_ACTIONS.MARKED_COMPLETE, // Choose a default action
		object_type: type, // First, a subcondition related to the resource itself
		object_id: id,
		object_title: title,
		parent_object_type: null,
		parent_object_id: null,
		parent_object_title: null,
	}];

	return (
		<RuleEditorForm
			initialValues={initialValues}
			{...props} />
	);

};

RuleEditor.propTypes = propTypes;

export default RuleEditor;
